import * as React from 'react';
import "./index.scss";
import { Pagination, message } from 'antd';
import { ReactComponent as EmptySvg } from './images/empty.svg';
import { requestResults, userToken } from '../../model/api';
import Expert from '../expert/expert';

export default class Results extends React.Component {
  _list = null;

  constructor(props) {
    super(props);
    this.state = {
      results: [], 
      page: 1,
      pageSize: 10,
      loading: true
    };

    this.handleMapResults = this.handleMapResults.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    if(this.props.id && this.props.total) {
      this.requestPage();
    }
  }

  componentDidUpdate(preProps, preState) {
    if(!this.props.id && !this.state.loading) {
      this.setState({loading: true, page: 1});
    }
    if(preState.page != this.state.page || this.props.id != preProps.id) {
      if(this.props.id) {
        this.requestPage();
      }
    }
  }

  requestPage() {
    const { page, pageSize } = this.state;
    requestResults(this.props.id, page, pageSize, this.props.dev_mode).then(data => {
      if (data.status == 0) {
        this.handleResults(data.data);
      } else {
        this.setState({ loading: false, results: [] });
        this.needLogin();
      }
    })
  }

  handleResults(results) {
    if (results) {
      this.setState({ results, loading: false });
    } else {
      this.setState({ loading: false });
    }
  }

  handleMapResults(value, index) {
    return (
        <div className='result' key={index}>
            <Expert data={value} dev_mode={this.props.dev_mode} result_id={this.props.id} />
        </div>
    );
  }

  needLogin() {
    message.warn("登陆后查看更多结果.");
    this.props.onShowLogin && this.props.onShowLogin();
  }

  handlePageChange(p) {
    if(userToken()) {
      if(this._list) {
        this._list.parentNode.scrollTop = 0;
      }
      this.setState({page: p, loading: true});
      this.props.onPageChange && this.props.onPageChange();
    }else {
      this.needLogin();
    }
  }

  render() {
    const { total, error } = this.props;
    const { results, page, loading, pageSize } = this.state;
    return (
      <div className='results' ref={r => this._list = r}>
        { (error || (!results.length && !loading)) && (
          <div className='empty'>
            <EmptySvg />
            <div className='tip'>无搜索结果，换个关键词试试？</div>
          </div>
        )}
        {
          !error && !!results && !!results.length && (
            <div className='list'>
              <div className='list_title'>{`为您推荐以下 ${total} 位学者:`}</div>
              {results.map(this.handleMapResults)}
              <div className='pagination'>
                <Pagination current={page} total={total} pageSize={pageSize} showQuickJumper showSizeChanger={false} onChange={this.handlePageChange}/>
              </div>
            </div>
          )
        }
        {
          !error && loading && (
            <div className='loading'>
              <img src={require('./images/loading.gif')} />
              <div className='tip'>智能推荐中...</div>
            </div>
          )
        }
      </div>
    )
  }
}